import { defineStore } from "pinia";
import { v4 } from "uuid";

import { CancelError } from "@/error";

export const useToastStore = defineStore("toast", {
  state: () => ({
    messages: [],
  }),

  actions: {
    addMessage(message) {
      this.messages.push(message);
    },
    removeMessageById(id) {
      this.messages = this.messages.filter((m) => m.id !== id);
    },
    showMessage({ message, type = "success" }) {
      if (!message) return;
      const id = v4();
      const messageObject = { message, type, id };
      this.addMessage(messageObject);
      setTimeout(
        () => {
          this.removeMessageById(id);
        },
        type === "success" ? 5000 : 10000,
      );
    },
    async showFeedback({ action, successMessage = "Operation completed successfully." }) {
      try {
        await action;
        this.showMessage({ message: successMessage });
      } catch (error) {
        // CancelErrors are intentional no-ops (e.g. the user backed out of a
        // confirmation) — surface neither a success nor an error toast.
        if (error instanceof CancelError) return;
        const message = error?.userMessage || error?.message || String(error);
        this.showMessage({ message, type: "error" });
        throw error;
      }
    },
  },
});
